<template>
  <div >
    <index-card :loading="loading">
      <template slot="header">
        <div class="d-flex align-center">
          <v-btn text icon large to="/" exact><v-icon class="white--text">mdi-arrow-left</v-icon></v-btn>
          <v-btn color="white" class="ml-1 blue-grey--text elavation-0 font-weight-bold" @click="$router.push('/companies/create')"
              center>
              <v-icon small left>mdi-plus</v-icon>Nova Empresa
          </v-btn>
        </div>
        <div class="d-flex align-center">
          <span class="headline white--text">
            {{ companies? companies.length : ''}} Empresas
          </span>
          <v-btn text icon @click="getData()" exact><v-icon class="white--text">mdi-refresh</v-icon></v-btn>
        </div>
      </template>
      <template slot="subheader">
        <div class="company-list-filters">
          <filter-data
            :with_client="false"
            :with_date_start="false"
            :with_date_end="false"
            with_text_search
            text_search_label="Pesquise.."
            :loading_block="loading"
            @doneFilter="handleDoneFilter"
          />
        </div>
      </template>
      <template slot="data_table">
        <v-data-table @click:row="editItem" :headers="headers" :items="companies"
          class="elevation-4" :search="search" v-if="!loading" mobile-breakpoint="1">
          <template v-slot:item.attributes.name="{item}">
              {{ item.attributes.name }}
          </template>
          <template v-slot:item.attributes.doc_number="{item}">
            {{
              item.attributes.doc_number,
              item.attributes.cpf_or_cnpj | DocumentPersonBr
            }}
          </template>
          <template v-slot:item.attributes.status.title="{item}">
            <v-chip small :color="status_map[item.attributes.status.title].color">
              <v-avatar left>
                <v-icon>{{status_map[item.attributes.status.title].icon}}</v-icon>
              </v-avatar>
              {{status_map[item.attributes.status.title].text}}
            </v-chip>
          </template>
          <template v-slot:no-results>
            <v-alert  :value="true" type="error" icon="mdi-alert">
              Não foi possível encontrar "{{ search }}".
            </v-alert>
          </template>
        </v-data-table>
      </template>
    </index-card>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Api from '@/api/index';

export default {
  name: 'CompanyList',
  components:{
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
    EditCompany: () => import('./ShowCompany.vue'),
    FilterData: () => import('@/components/shared/FilterData.vue'),
  },
  data() {
    return {
      loading: true,
      companies: null,
      search: '',
      levels: {
        0: { color: 'yellow', limiter: 0, active: true, description: "Nenhuma atividade" },
        1: { color: 'green', limiter: 16, active: true, description: "Ativo (0 - 15)" },
        2: { color: 'orange', limiter: 31, active: true, description: "(16 - 30)" },
        3: { color: 'red', limiter: 61, active: true, description: "(31 - 60)" },
        4: { color: 'purple', limiter: -1, active: true, description: "Inativo (+ 61)" },
      },
      headers: [
        { text: 'Rz Social / Nome', value: 'attributes.name', align: 'center' },
        { text: 'Nome Fantasia', value: 'attributes.fantasyName', align: 'center' },
        { text: 'Nome Corporativo', value: 'attributes.corporateName', align: 'center' },
        { text: 'CPF/CNPJ', value: 'attributes.CNPJ', align: 'center' },
        { text: 'Status', value: 'attributes.status.title', align: 'center' },
      ],
      status_map: {
        Active: { color: 'success', icon:'mdi-check',text: 'Ativo'}, 
        Inactive: { color: 'warning', icon:'mdi-alert',text: 'Inativo'}, 
        Suspended: { color: 'warning', icon:'mdi-alert',text: 'Suspendido'}, 
        Excluded: { color: 'error', icon:'mdi-delete',text: 'Excluído'}, 
        Canceled: { color: 'error', icon:'mdi-cancel',text: 'Cancelado'}
      },
    }
  },
  methods: {
    getData(){
      this.getCompanies()
    },
    handleDoneFilter(filter = {}) {
      this.search = filter.query ? String(filter.query) : ''
    },
    editItem(item) {
      this.$router.push({name: 'ShowCompany', params: {id: item.id}})
    },
    async getCompanies(){
      this.loading = true
      await Api.Company.index().then(r => {
        this.companies = [...r.data.data]
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.loading = false
      })
    },
    ...mapActions({
      
    })
  },
  computed: {
    ...mapState({

    }),
  },
  mounted() {
    this.getCompanies()
  },
  watch: {

  },
}
</script>

<style scoped>
.company-list-filters {
  width: 100%;
  flex: 1 1 100%;
  min-width: 0;
}
.company-list-filters >>> .filter-data-card {
  width: 100%;
}
</style>